export default {
    COLOR_OPTION_ID: 93,
    SIZE_OPTION_ID: 141,
    GIFT_CARD_PRICE_OPTION_ID: 216
}